import { createAction } from "@reduxjs/toolkit";

// Clears all cache and state - handled by middleware in store/index.ts
export const resetAll = createAction("RESET_ALL");
